import React, { useState } from 'react';
import './UserInteraction.css';
import { FiUsers, FiEye, FiClock, FiTrendingUp, FiBarChart2, FiPieChart } from 'react-icons/fi';

const UserInteraction = () => {
  // Dummy data for user interactions
  const [analytics] = useState({
    totalUsers: 12500,
    activeUsers: 3420,
    pageViews: 45678,
    averageTime: '4m 32s',
    bounceRate: '32%',
    trafficSources: {
      direct: 45,
      search: 30,
      social: 15,
      referral: 10
    },
    dailyVisitors: [
      { date: '2024-03-10', visitors: 1200 },
      { date: '2024-03-11', visitors: 1450 },
      { date: '2024-03-12', visitors: 1320 },
      { date: '2024-03-13', visitors: 1680 },
      { date: '2024-03-14', visitors: 1890 },
      { date: '2024-03-15', visitors: 2100 },
      { date: '2024-03-16', visitors: 1980 }
    ],
    popularPages: [
      { page: '/market-analysis', views: 12500 },
      { page: '/stock-recommendations', views: 9800 },
      { page: '/research-reports', views: 7500 },
      { page: '/portfolio-tools', views: 6200 },
      { page: '/educational-resources', views: 5800 }
    ],
    userEngagement: {
      averagePagesPerVisit: 4.2,
      returningVisitors: 65,
      newVisitors: 35
    }
  });

  return (
    <div className="user-interaction-container">
      <h2>Website Analytics Dashboard</h2>
      <p className="subtitle">User Interaction Metrics for TrillionStockResearch.com</p>

      {/* Key Metrics Cards */}
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-icon total-users">
            <FiUsers />
          </div>
          <div className="metric-info">
            <h3>Total Users</h3>
            <p>{analytics.totalUsers.toLocaleString()}</p>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon active-users">
            <FiTrendingUp />
          </div>
          <div className="metric-info">
            <h3>Active Users</h3>
            <p>{analytics.activeUsers.toLocaleString()}</p>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon page-views">
            <FiEye />
          </div>
          <div className="metric-info">
            <h3>Page Views</h3>
            <p>{analytics.pageViews.toLocaleString()}</p>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon avg-time">
            <FiClock />
          </div>
          <div className="metric-info">
            <h3>Avg. Time on Site</h3>
            <p>{analytics.averageTime}</p>
          </div>
        </div>
      </div>

      {/* Traffic Sources Chart */}
      <div className="chart-section">
        <h3>Traffic Sources</h3>
        <div className="traffic-sources">
          {Object.entries(analytics.trafficSources).map(([source, percentage]) => (
            <div key={source} className="source-item">
              <div className="source-bar">
                <div 
                  className="source-fill" 
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
              <div className="source-label">
                <span className="source-name">{source.charAt(0).toUpperCase() + source.slice(1)}</span>
                <span className="source-percentage">{percentage}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Daily Visitors Chart */}
      <div className="chart-section">
        <h3>Daily Visitors (Last 7 Days)</h3>
        <div className="visitors-chart">
          {analytics.dailyVisitors.map((day) => (
            <div key={day.date} className="visitor-bar">
              <div 
                className="visitor-fill"
                style={{ 
                  height: `${(day.visitors / Math.max(...analytics.dailyVisitors.map(d => d.visitors))) * 100}%` 
                }}
              ></div>
              <span className="visitor-label">{day.date.split('-')[2]}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Popular Pages */}
      <div className="chart-section">
        <h3>Most Popular Pages</h3>
        <div className="popular-pages">
          {analytics.popularPages.map((page) => (
            <div key={page.page} className="page-item">
              <div className="page-name">{page.page}</div>
              <div className="page-views">
                <div 
                  className="page-fill"
                  style={{ 
                    width: `${(page.views / analytics.popularPages[0].views) * 100}%` 
                  }}
                ></div>
                <span className="view-count">{page.views.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* User Engagement Metrics */}
      <div className="engagement-section">
        <h3>User Engagement</h3>
        <div className="engagement-grid">
          <div className="engagement-card">
            <FiBarChart2 className="engagement-icon" />
            <div className="engagement-info">
              <h4>Pages per Visit</h4>
              <p>{analytics.userEngagement.averagePagesPerVisit}</p>
            </div>
          </div>
          <div className="engagement-card">
            <FiPieChart className="engagement-icon" />
            <div className="engagement-info">
              <h4>Returning Visitors</h4>
              <p>{analytics.userEngagement.returningVisitors}%</p>
            </div>
          </div>
          <div className="engagement-card">
            <FiUsers className="engagement-icon" />
            <div className="engagement-info">
              <h4>New Visitors</h4>
              <p>{analytics.userEngagement.newVisitors}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInteraction;
